export default "__VITE_ASSET__e6c28b7c__"